import * as React from "react";
import { style } from "typestyle";
import SidebarItem from "./SidebarItem";
import { grey1 } from "./_colors";
import { connect } from "react-redux";
import { IGcpAppDispatchProp } from "../../redux/store";
import {
  userCollapsesActiveFmGroup,
  userCollapsesRequestedFmGroup,
  userExpandsActiveFmGroup,
  userExpandsRequestedFmGroup,
} from "../scenarios";

interface ISidebarGroupProps extends IGcpAppDispatchProp {
  className?: string;
  title: string;
  titleElement?: React.JSX.Element;
  children: any;
  onCheckboxClick: () => void;
  isChecked: boolean;
  rightLabel?: string;
  isExpandedInitially?: boolean;
}

function SidebarGroup({
  className,
  title,
  titleElement,
  children,
  onCheckboxClick,
  isChecked,
  rightLabel,
  isExpandedInitially = false,
  dispatch,
}: ISidebarGroupProps) {
  const [isExpanded, setIsExpanded] = React.useState(isExpandedInitially);

  const handleExpanded = () => {
    if (title === "Active") {
      if (isExpanded) {
        dispatch(userCollapsesActiveFmGroup());
      } else {
        dispatch(userExpandsActiveFmGroup());
      }
    } else {
      if (isExpanded) {
        dispatch(userCollapsesRequestedFmGroup());
      } else {
        dispatch(userExpandsRequestedFmGroup());
      }
    }

    setIsExpanded(!isExpanded);
  };

  const renderHeader = () => (
    <SidebarItem
      className={className}
      backgroundColor={grey1}
      borderBottomColor="#E5E5E5"
      leftIcon={
        <img
          src={isChecked ? "icon-checkbox-on.svg" : "icon-checkbox-off.svg"}
        />
      }
      leftLabel={
        <div className={style({ fontWeight: "bold" })}>
          {titleElement || title}
        </div>
      }
      rightLabel={rightLabel}
      rightIcon={
        <img
          src={isExpanded ? "icon-arrow-down.svg" : "icon-arrow-right.svg"}
        />
      }
      onLeftIconClick={onCheckboxClick}
      onLeftLabelClick={handleExpanded}
      onRightLabelClick={handleExpanded}
      onRightIconClick={handleExpanded}
    />
  );

  return (
    <>
      {renderHeader()}
      {isExpanded && children}
    </>
  );
}

export default connect()(SidebarGroup);
